<!-- Header -->
<mat-card>
  <mat-card-header>
    <div class="header-container">
      <div class="left-content">
        <lib-key [hierarchyItem]="selectiveData.masterKey"> </lib-key>
        <span class="header-text">Update Key(s) Type</span>
      </div>
      <button mat-icon-button class="close-button" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-header>
</mat-card>

<!-- Content -->
  <mat-card-content class="margin padding all">
    <form [formGroup]="changeForm" (keyup.enter)="submit()">
      <div class="row">
        <p>Enter individual keys separated by a comma.</p>
      </div>
      <!-- Key Names -->
      <div class="row">
        <mat-form-field class="full-width" floatLabel="always" appearance="outline">
            <mat-label
              for="keySetSymbols"
              [ngClass]="{
                'error-message': fieldHasError(changeForm, 'keySetSymbols'),
                focus: focus.keySetSymbols
              }"
            >
              Key Names
            </mat-label>

            <input
              id="keySetSymbols"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(changeForm, 'keySetSymbols'),
              disabled: false,
              'focus-border': focus.keySetSymbols
            }"
              placeholder="Enter Key Names"
              formControlName="keySetSymbols"
              autocomplete="off"
              (focus)="focusOn('keySetSymbols')"
              (focusout)="focusOn('keySetSymbols')"
              aria-describedby="keySetSymbols errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(changeForm, 'keySetSymbols')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.keySetSymbols" id="keySetSymbolsErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(changeForm, validation, 'keySetSymbols')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
      <div class="row">
        <p>Or enter groups of keys by range:</p>
      </div>
      <!-- Prefix -->
      <div class="row">
        <mat-form-field floatLabel="always" appearance="outline" class="quarter-width margin lrg right">
            <mat-label
              for="prefix"
              [ngClass]="{
                'error-message': fieldHasError(changeForm, 'prefix'),
                focus: focus.prefix
              }"
            >
              Prefix
            </mat-label>
            <input
              id="prefix"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(changeForm, 'prefix'),
              disabled: false,
              'focus-border': focus.prefix
            }"
              placeholder="Enter Prefix"
              formControlName="prefix"
              (focus)="focusOn('prefix')"
              (focusout)="focusOn('prefix')"
              aria-describedby="prefix errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(changeForm, 'prefix')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.prefix" id="prefixErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(changeForm, validation, 'prefix')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
     

      <!-- from -->

        <mat-form-field floatLabel="always" appearance="outline" class="quarter-width margin lrg left right">
            <mat-label
              for="from"
              [ngClass]="{
                'error-message': fieldHasError(changeForm, 'from'),
                focus: focus.from
              }"
            >
              From <span *ngIf="lasSKD?.keySetSymbol">( Last used: {{ lasSKD?.keySetSymbol }} )</span>
            </mat-label>
            <input
              id="from"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(changeForm, 'from'),
              disabled: false,
              'focus-border': focus.from
            }"
              maxlength="{{ max }}"
              placeholder="Enter From"
              formControlName="from"
              (focus)="focusOn('from')"
              (focusout)="focusOn('from')"
              aria-describedby="from errors"
              matInput
            />

            <mat-icon *ngIf="fieldHasError(changeForm, 'from')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.from" id="fromErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(changeForm, validation, 'from')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>


      <!-- to -->

        <mat-form-field floatLabel="always" appearance="outline" class="quarter-width margin lrg left right">
            <mat-label
              for="to"
              [ngClass]="{
                'error-message': fieldHasError(changeForm, 'to'),
                focus: focus.to
              }"
            >
              To
            </mat-label>
            <input
              id="to"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(changeForm, 'to'),
              disabled: false,
              'focus-border': focus.to
            }"
              maxlength="{{ max }}"
              placeholder="Enter To"
              formControlName="to"
              (focus)="focusOn('to')"
              (focusout)="focusOn('to')"
              aria-describedby="to errors"
              min="0"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(changeForm, 'to')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.to" id="toErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(changeForm, validation, 'to')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>


      <!-- Suffix -->

        <mat-form-field floatLabel="always" appearance="outline" class="quarter-width margin lrg left right">
            <mat-label
              for="suffix"
              [ngClass]="{
                'error-message': fieldHasError(changeForm, 'suffix'),
                focus: focus.suffix
              }"
            >
              Suffix
            </mat-label>
            <input
              id="suffix"
              class="uppercase"
              [ngClass]="{
              error: fieldHasError(changeForm, 'suffix'),
              disabled: false,
              'focus-border': focus.suffix
            }"
              placeholder="Enter Suffix"
              formControlName="suffix"
              (focus)="focusOn('suffix')"
              (focusout)="focusOn('suffix')"
              aria-describedby="suffix errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(changeForm, 'suffix')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
            </mat-icon>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.suffix" id="suffixErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(changeForm, validation, 'suffix')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
      <!---Key Type to change to --->
      <div class="row full-width">
        <mat-form-field floatLabel="always" appearance="outline" class="full-width margin lrg right">
          <mat-label>Change To</mat-label>
          <mat-select
            [ngClass]="{
              'error': fieldHasError(changeForm, 'masterKeyTypeId'),
              'focus-border': focus.masterKeyTypeId
            }"
            (focus)="focusOn('masterKeyTypeId')"
            (focusout)="focusOn('masterKeyTypeId')"
            placeholder="Select key type"
            formControlName="masterKeyTypeId"
          >
            <mat-option *ngFor="let keyType of keyTypeList" [value]="keyType.id">
              {{ keyType.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </form>
  </mat-card-content>

<!-- Buttons -->
<mat-card-actions>
  <div class="row">
    <button mat-stroked-button id="cancel" (click)="close()"> Cancel </button>
    <button 
      mat-flat-button
      class="margin left"
      color="primary"
      id="save"
      (click)="checkAssignedKeyCombinations()"
      [disabled]="!changeForm.valid"
    >
      Confirm
    </button>
  </div>
</mat-card-actions>
